import { Box, SxProps } from '@mui/material';
import MedicalCare from './MedicalCare.svg';
import MedicalCarePrimary from './MedicalCarePrimary.svg';

type Props = {
  color?: 'primary' | 'default';
  width?: number;
  height?: number;
  sxProps?: SxProps;
};

export function MedicalCareIcon({
  color = 'primary',
  width = 24,
  height = 24,
  sxProps,
}: Props) {
  const icon = color === 'primary' ? MedicalCarePrimary : MedicalCare;

  return (
    <Box
      component="img"
      src={icon.src}
      width={width}
      height={height}
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        ...sxProps,
      }}
    />
  );
}
